import { useEffect, useRef } from "react";

const useEffectSkipFirst = (fn, dependency) => {
  const dependencyRef = useRef(dependency);

  useEffect(() => {
    if (dependency !== dependencyRef.current) {
      fn();
      dependencyRef.current = dependency;
    }
  }, [fn,dependency]);
};

export default useEffectSkipFirst;